import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import '../styles/Form.css';
import '../styles/Notifications.css';

const Candidatura = () => {
  const [formData, setFormData] = useState({
    nombre: '',
    apellidos: '',
    telefono: '',
    categoria: '',
    email: '',
    redes_sociales: '',
    mensaje: '',
    foto: null,
    aceptaPolitica: false,
  });

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;
    if (type === 'checkbox') {
      setFormData({
        ...formData,
        [name]: checked,
      });
    }
    else if (name === 'foto') {
      setFormData({
        ...formData,
        [name]: files[0],
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };


  // Configura los parámetros según tu plantilla de EmailJS

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);

    if (!formData.aceptaPolitica) {
      setError('Debes aceptar la política de tratamiento de datos.');
      setTimeout(() => setError(null), 3000);
      return;
    }

    const templateParams = {
      nombre: formData.nombre,
      apellidos: formData.apellidos,
      telefono: formData.telefono,
      email: formData.email,
      categoria: formData.categoria,
      redes_sociales: formData.redes_sociales,
      mensaje: formData.mensaje,
    };

    emailjs
      .send(
        'service_hbxq0xd', // Tu Service ID
        'template_v5snb6d', // Tu Template ID
        templateParams,
        'DrbmVpjAvwWZ7Ntms' // Tu User ID
      )
      .then(
        () => {
          setSuccess(true);
          setFormData({
            nombre: '',
            apellidos: '',
            telefono: '',
            email: '',
            categoria: '',
            redes_sociales: '',
            mensaje: '',
            aceptaPolitica: false,
          });

          setTimeout(() => setSuccess(false), 3000); // Ocultar mensaje de éxito tras 3 segundos
        },
        (err) => {
          setError('Hubo un error al enviar la candidatura.');
          console.error('ErrorCandidatura:', err);
          setTimeout(() => setError(null), 3000); // Ocultar mensaje de error tras 3 segundos
        }
      );
  };

  return (
    <div className="form-container">
      {/* Mostrar notificaciones de error o éxito */}
      {error && <p className="notification error">{error}</p>}
      {success && <p className="notification success">¡Candidatura registrada exitosamente!</p>}

      <form onSubmit={handleSubmit} className="cuerpo-form">
        {/* Campos del formulario */}
        <div className="form-group">
          <div className="form-group-item">
            <label className="form-label">
              Nombre *
              <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} required />
            </label>
          </div>
          <div className="form-group-item">
            <label className="form-label">
              Apellidos *
              <input type="text" name="apellidos" value={formData.apellidos} onChange={handleChange} required />
            </label>
          </div>
        </div>

        <div className="form-group">
          <div className="form-group-item">
            <label className="form-label">Teléfono *</label>
            <input type="text" name="telefono" value={formData.telefono} onChange={handleChange} required />
          </div>
          <div className="form-group-item">
            <label className="form-label">
              Categoría *
              <select name="categoria" value={formData.categoria} onChange={handleChange} required>
                <option value="">Selecciona una categoría</option>
                <option value="Artista o grupo musical">Artista o grupo musical</option>
                <option value="Beauty, lifestyle y moda">Beauty, lifestyle y moda</option>
                <option value="Creador de contenido">Creador de contenido</option>
                <option value="Entretenimiento digital">Entretenimiento digital</option>
                <option value="Emprendimiento">Emprendimiento</option>
                <option value="Deportes">Deportes</option>
              </select>
            </label>
          </div>
        </div>

        <div className="form-group">
          <div className="form-group-item">
            <label className="form-label">
              Email *
              <input type="email" name="email" value={formData.email} onChange={handleChange} required />
            </label>
          </div>
          <div className="form-group-item">
            <label className="form-label">
              Redes Sociales (enlaces):
              <input type="text" name="redes_sociales" value={formData.redes_sociales} onChange={handleChange} required />
            </label>
          </div>

          {/*
          <div className="form-group-item">
            <label className="form-label">
              Foto:
              <input type="file" name="foto" accept="image/*" onChange={handleChange} />
            </label>
          </div>
          */}

        </div>

        <div className="form-group-full">
          <label className="form-label">
            Mensaje *
            <textarea name="mensaje" value={formData.mensaje} onChange={handleChange} required></textarea>
          </label>
        </div>

        <button className="button-gold" type="submit">
          Enviar candidatura
        </button>

        {/* Checkbox para aceptar la política de datos */}
        <p className="privacy-note">
          <label>
            <input
              type="checkbox"
              name="aceptaPolitica"
              checked={formData.aceptaPolitica}
              onChange={handleChange}
              required
            />
            Acepto la{' '}
            <strong>
              <a href="/politica-datos" target="_blank" rel="noopener noreferrer">
                política de tratamiento de datos personales
              </a>
            </strong>
          </label>
        </p>
      </form>
    </div>
  );
};

export default Candidatura;